(function ($, document, window) {
	'use strict';

	$(function () {
		const $carousel = $('.js-logo-carousel');
		const $slides = $carousel.find('.js-logo-carousel-item');
		const totalSlides = $slides.length ?? 0;
		const minSlidesForLoop = 8;

		const swiper = new Swiper('.js-logo-carousel', {
			direction: 'horizontal',
			slidesPerView: 'auto',
			spaceBetween: 50,
			centerInsufficientSlides: totalSlides < minSlidesForLoop,
			speed: 3500,
			autoplay: {
				delay: 0,
				disableOnInteraction: false,
			},
			loop: totalSlides >= minSlidesForLoop,
			allowTouchMove: totalSlides < minSlidesForLoop,
			grabCursor: totalSlides < minSlidesForLoop,

			breakpoints: {
				768: {
					spaceBetween: 70,
				},

				1024: {
					spaceBetween: 100,
				}
			},
		});
	});
})(jQuery, document, window);
